module.exports = __webpack_public_path__ + "img/platform8.4a951ebd.png";